import Vue from 'vue'
import { Auth, API, graphqlOperation } from 'aws-amplify'
import * as queries from '@/graphql/queries'
import * as mutations from '@/graphql/mutations'

const actions = {
  // table data
  getItems ({ commit, getters, dispatch }, [params]) {
    console.log('getItems')
    return new Promise((resolve, reject) => {
      commit('setLoadingStatus', true)
      Auth.currentSession().then(result => {
        API.graphql(graphqlOperation(queries[`${getters.list}`], params))
          .then(response => {
            commit('setItemsServerSide', response.data[`${getters.list}`])
            resolve()
          })
          .catch(error => {
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
  },
  getItemsServerSide ({ commit, getters, dispatch }, [params]) {
    console.log('getItemsServerSide')
    return new Promise((resolve, reject) => {
      commit('setLoadingStatus', true)
      Auth.currentSession().then(result => {
        console.log(params)
        // let nextToken = `limit=${params.limit}&offset=${params.offset}`
        API.graphql(graphqlOperation(queries[`${getters.list}`], params))
          .then(response => {
            commit('setItemsServerSide', response.data[`${getters.list}`])
            commit('setLoadingStatus', false)
            resolve()
          })
          .catch(error => {
            commit('setLoadingStatus', false)
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
  },
  // item details
  getItem ({ commit, getters, dispatch }, [id]) {
    console.log('getItem')
    return new Promise((resolve, reject) => {
      commit('setDetailsLoader', true)
      Auth.currentSession().then(result => {
        API.graphql(graphqlOperation(queries[`${getters.get}`], { id: id }))
          .then(response => {
            commit('setItem', response.data[`${getters.get}`])
            commit('setDetailsLoader', false)
            resolve()
          })
          .catch(error => {
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
  },
  updateItem ({
    getters, dispatch,
  }, [
    id,
    params,
    successText,
    errorText,
  ]) {
    console.log('updateItem')
    return new Promise((resolve, reject) => {
      Auth.currentSession().then(result => {
        params.id = id
        API.graphql(graphqlOperation(mutations[`${getters.update}`], { input: params }))
          .then(response => {
            dispatch('openAlertBox', [
              'alertSuccess',
              successText,
            ], { root: true })
            dispatch('runItemsViewRefreshing')
            resolve()
          })
          .catch(error => {
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
  },
  storeItem ({
    commit, state, getters, dispatch,
  }, [
    params,
    successText,
    errorText,
  ]) {
    console.log('storeItem')
    return new Promise((resolve, reject) => {
      Auth.currentSession().then(result => {
        console.log('storeItem')
        console.log(params)
        API.graphql(graphqlOperation(mutations[`${getters.create}`], { input: params }))
          .then(response => {
            dispatch('openAlertBox', [
              'alertSuccess',
              successText,
            ], { root: true })
            dispatch('runItemsViewRefreshing')
            resolve()
            if (state.createdElement.mode === 'inform') {
              commit('setCreatedItemStatus', [
                true,
                response.data[`${getters.create}`].item,
              ])
            }
          })
          .catch(error => {
            console.log(error)
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
  },
  deleteItem ({
    getters, dispatch,
  }, [
    id,
    successText,
    errorText,
  ]) {
    console.log('deleteItem')
    Auth.currentSession().then(result => {
      API.graphql(graphqlOperation(mutations[`${getters.remove}`], { input: { id: id } }))
        .then(response => {
          dispatch('openAlertBox', [
            'alertSuccess',
            successText,
          ], { root: true })
          dispatch('runItemsViewRefreshing')
        })
        .catch(error => {
          console.log(error)
          dispatch('openAlertBox', [
            'alertError',
            error.statusText,
          ], { root: true })
        })
    })
  },
  mulitipleItemsUpdate ({
    getters, dispatch,
  }, [
    params,
    successText,
    errorText,
  ]) {
    console.log('multipleItemsUpdate')
    Vue.http.post(`${getters.path('mu')}/multiple-update`, params)
      .then(() => {
        dispatch('openAlertBox', [
          'alertSuccess',
          successText,
        ], { root: true })
        dispatch('runItemsViewRefreshing')
      }, () => {
        dispatch('openAlertBox', [
          'alertError',
          errorText,
        ], { root: true })
      })
  },
  mulitipleItemsDelete ({
    getters, dispatch,
  }, [
    ids,
    successText,
    errorText,
  ]) {
    console.log('multipleItemsDelete')
    Vue.http.post(`${getters.path('md')}/multiple-delete`, ids)
      .then(() => {
        dispatch('openAlertBox', [
          'alertSuccess',
          successText,
        ], { root: true })
        dispatch('runItemsViewRefreshing')
      }, () => {
        dispatch('openAlertBox', [
          'alertError',
          errorText,
        ], { root: true })
      })
  },
  // item elements
  getItemElements ({ commit, state }) {
    console.log('getItemElements')
    Auth.currentSession().then(result => {
      API.graphql(graphqlOperation(queries[state.itemElements.query], {
        filter: {
          userID: {
            eq: state.itemElements.id,
          },
        },
        limit: 20,
      }
      ))
        .then(response => {
          var permissions = []
          response.data[state.itemElements.query].items.forEach(function (item, index) {
            permissions.push(item.permission)
          })
          commit('setItemElements', permissions)
        })
    })
  },
  addItemElement ({
    dispatch, state,
  }, [
    params,
    successText,
    errorText,
  ]) {
    console.log('addItemElement')
    // Vue.http.post(state.itemElements.controller, params)
    //   .then(() => {
    //     dispatch('openAlertBox', [
    //       'alertSuccess',
    //       successText,
    //     ], { root: true })
    //     dispatch('getItemElements')
    //   }, () => {
    //     dispatch('openAlertBox', [
    //       'alertError',
    //       errorText,
    //     ], { root: true })
    //   })
  },
  removeItemElement ({
    dispatch, state,
  }, [
    id,
    successText,
    errorText,
  ]) {
    console.log('removeItemElement')
    Vue.http.delete(`${state.itemElements.controller}/${id}`)
      .then(() => {
        dispatch('openAlertBox', [
          'alertSuccess',
          successText,
        ], { root: true })
        dispatch('getItemElements')
      }, () => {
        dispatch('openAlertBox', [
          'alertError',
          errorText,
        ], { root: true })
      })
  },
  addManyItemElements ({
    dispatch, state,
  }, [
    params,
    successText,
    errorText,
  ]) {
    console.log('addManyItemElements')
    Vue.http.post(`${state.itemElements.controller}/multiple-add`, params)
      .then(() => {
        dispatch('openAlertBox', [
          'alertSuccess',
          successText,
        ], { root: true })
        dispatch('getItemElements')
      }, () => {
        dispatch('openAlertBox', [
          'alertError',
          errorText,
        ], { root: true })
      })
  },
  removeManyItemElements ({
    dispatch, state,
  }, [
    ids,
    successText,
    errorText,
  ]) {
    console.log('removeManyElements')
    Vue.http.post(`${state.itemElements.controller}/multiple-delete`, ids)
      .then(() => {
        dispatch('openAlertBox', [
          'alertSuccess',
          successText,
        ], { root: true })
        dispatch('getItemElements')
      }, () => {
        dispatch('openAlertBox', [
          'alertError',
          errorText,
        ], { root: true })
      })
  },
  // extented details
  getItemDetails ({ commit, getters, dispatch }, [id]) {
    /*
    console.log('getItemDetails')
    return new Promise((resolve, reject) => {
      commit('setDetailsLoader', true)
      Auth.currentSession().then(result => {
        let promises = []
        let promise = API.graphql(graphqlOperation(queries[`${getters.get}`], { id: id }))
          .then(response => {
            commit('itemDetails', response.data[`${getters.get}`])
            console.log('setItemDetails Main')
          })
          .catch(error => {
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
          })
        promises.push(promise)

        // let childItems = getters.children
        let childItems = getters.childrenMapping
        console.log('children')
        childItems.forEach(function (item, index) {
          // console.log('more information')
          // console.log(item.name)
          // console.log(item.objName)
          // console.log(item.fkName)
          let childItemName = item.name
          let sparams = {
            filter: {},
            limit: 20,
          }
          sparams.filter[item.fkName] = {
            eq: id
          }
          promise = API.graphql(graphqlOperation(queries[item.fetchFn], sparams))
            .then(response => {
              // console.log(response)
              commit('setChildItems', [ response.data[item.fetchFn], childItemName])
              console.log('setItemDetails Child: ' + childItemName)
            })
            .catch(error => {
              dispatch('openAlertBox', [
                'alertError',
                error.statusText,
              ], { root: true })
            })
          console.log('add to promises')
          promises.push(promise)
        })

        console.log('wait for all promises')
        console.log('count promises: ' + promises.length)
        console.log(promises[0])
        console.log(promises[1])
        Promise.all(promises)
          .then(response => {
            commit('setDetailsLoader', false)
            console.log("resolved!")
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    })
    */

    return new Promise((resolve, reject) => {
      commit('setDetailsLoader', true)
      Auth.currentSession().then(result => {
        API.graphql(graphqlOperation(queries[`${getters.get}`], { id: id }))
          .then(response => {
            commit('itemDetails', response.data[`${getters.get}`])
            let promises = []
            getters.childrenMapping.forEach(function (item, index) {
              let sparams = {
                filter: {},
                limit: 20,
              }
              sparams.filter[item.fkName] = {
                eq: id,
              }
              let promise = API.graphql(graphqlOperation(queries[item.fetchFn], sparams))
                .then(response => {
                  commit('setChildItems', [
                    response.data[item.fetchFn],
                    item.name,
                  ])
                })
                // .catch(error => {
                //   dispatch('openAlertBox', [
                //     'alertError',
                //     error.statusText,
                //   ], { root: true })
                // })
              // console.log('add to promises')
              promises.push(promise)
            })

            Promise.all(promises)
              .then(response => {
                commit('setDetailsLoader', false)
                resolve()
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })

    // return new Promise((resolve, reject) => {
    //   commit('setDetailsLoader', true)
    //   Vue.http.get(`${getters.path('sh')}/${id}`)
    //     .then((response) => {
    //       commit('itemDetails', response.body)
    //       commit('setDetailsLoader', false)
    //       resolve()
    //     }, (error) => {
    //       dispatch('openAlertBox', [
    //         'alertError',
    //         error.statusText,
    //       ], { root: true })
    //       reject(error)
    //     })
    // })
  },
  updateItemDetail ({
    dispatch, state, getters,
  }, [
    id,
    params,
    successText,
  ]) {
    console.log('updateItemDetail')
    Auth.currentSession().then(result => {
      params.id = id
      API.graphql(graphqlOperation(mutations[`${getters.update}`], { input: params }))
        .then(response => {
          dispatch('openAlertBox', [
            'alertSuccess',
            successText,
          ], { root: true })
          dispatch('getItemDetails', [state.item[state.itemIdColumn]])
        })
        .catch(error => {
          dispatch('openAlertBox', [
            'alertError',
            error.statusText,
          ], { root: true })
        })
    })
    // Vue.http.put(`${getters.path('u')}/${id}`, params)
    //   .then((response) => {
    //     if (response.body.status === 0) {
    //       dispatch('openAlertBox', [
    //         'alertSuccess',
    //         successText,
    //       ], { root: true })
    //     } else if (response.body.status === -1) {
    //       dispatch('openAlertBox', [
    //         'alertError',
    //         response.body.msg,
    //       ], { root: true })
    //     } else if (response.body.status === -2) {
    //       dispatch('openAlertBox', [
    //         'alertValidationError',
    //         response.body.msg,
    //       ], { root: true })
    //     }
    //     dispatch('getItemDetails', [state.item[state.itemIdColumn]])
    //   }, (error) => {
    //     dispatch('openAlertBox', [
    //       'alertError',
    //       error.statusText,
    //     ], { root: true })
    //   })
  },
  // child details
  updateChild ({
    dispatch, state,
  }, [
    params,
    action,
    successText,
  ]) {
    console.log('updateChild')
    return new Promise((resolve, reject) => {
      Auth.currentSession().then(result => {
        API.graphql(graphqlOperation(mutations[action], params))
          .then(response => {
            dispatch('openAlertBox', [
              'alertSuccess',
              successText,
            ], { root: true })
            resolve()
            // only reload actual child instead?
            console.log('123456')
            console.log(state.item[state.itemIdColumn])
            dispatch('getItemDetails', [state.item[state.itemIdColumn]])
          })
          .catch(error => {
            console.log(error)
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
    /*
    return new Promise((resolve, reject) => {
      Vue.http.put(`${path}/${id}`, params)
        .then((response) => {
          if (response.body.status === 0) {
            dispatch('openAlertBox', [
              'alertSuccess',
              successText,
            ], { root: true })
            resolve()
          } else if (response.body.status === -1) {
            dispatch('openAlertBox', [
              'alertError',
              response.body.msg,
            ], { root: true })
          } else if (response.body.status === -2) {
            dispatch('openAlertBox', [
              'alertValidationError',
              response.body.msg,
            ], { root: true })
          }
          dispatch('getItemDetails', [state.item[state.itemIdColumn]])
        }, (error) => {
          dispatch('openAlertBox', [
            'alertError',
            error.statusText,
          ], { root: true })
          reject(error)
        })
    })
    */
  },
  deleteChild ({
    dispatch, state,
  }, [
    id,
    successText,
    errorText,
    path,
  ]) {
    console.log('deleteChild')
    Vue.http.delete(`${path}/${id}`)
      .then((response) => {
        if (response.body.status === 0) {
          dispatch('openAlertBox', [
            'alertSuccess',
            successText,
          ], { root: true })
        } else if (response.body.status === -1) {
          dispatch('openAlertBox', [
            'alertError',
            response.body.msg,
          ], { root: true })
        } else if (response.body.status === -2) {
          dispatch('openAlertBox', [
            'alertValidationError',
            response.body.msg,
          ], { root: true })
        }
        dispatch('getItemDetails', [state.item[state.itemIdColumn]])
      }, () => {
        dispatch('openAlertBox', [
          'alertError',
          errorText,
        ], { root: true })
      })
  },
  storeChild ({
    dispatch, state,
  }, [
    params,
    successText,
    path,
  ]) {
    console.log('storeChild')
    return new Promise((resolve, reject) => {
      Auth.currentSession().then(result => {
        console.log('storeChild')
        console.log(params)
        API.graphql(graphqlOperation(mutations[path], { input: params }))
          .then(response => {
            dispatch('openAlertBox', [
              'alertSuccess',
              successText,
            ], { root: true })
            resolve()
            dispatch('getItemDetails', [state.item[state.itemIdColumn]])
          })
          .catch(error => {
            console.log(error)
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
    /*
    console.log('storeChild')
    return new Promise((resolve, reject) => {
      Vue.http.post(path, params)
        .then((response) => {
          if (response.body.status === 0) {
            dispatch('openAlertBox', [
              'alertSuccess',
              successText,
            ], { root: true })
            resolve()
          } else if (response.body.status === -1) {
            dispatch('openAlertBox', [
              'alertError',
              response.body.msg,
            ], { root: true })
          } else if (response.body.status === -2) {
            dispatch('openAlertBox', [
              'alertValidationError',
              response.body.msg,
            ], { root: true })
          }
          dispatch('getItemDetails', [state.item[state.itemIdColumn]])
        }, (error) => {
          dispatch('openAlertBox', [
            'alertError',
            error.statusText,
          ], { root: true })
          reject(error)
        })
    })
    */
  },
  /*
  getChildItems ({ commit, dispatch }, [
    params,
    action,
    childItemName,
  ]) {
    console.log('getChildItems')
    return new Promise((resolve, reject) => {
      Auth.currentSession().then(result => {

        API.graphql(graphqlOperation(queries[action], params))
          .then(response => {
            console.log(response)
            commit('setChildItems', [ response.data[action], childItemName])
            resolve()
          })
          .catch(error => {
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })
  },
  */
  getChild ({ commit, dispatch }, [
    params,
    action,
    childItemName,
  ]) {
    console.log('getChild')
    return new Promise((resolve, reject) => {
      Auth.currentSession().then(result => {
        console.log('getChild')
        console.log(params)
        console.log(action)
        console.log(childItemName)
        API.graphql(graphqlOperation(queries[action], params))
          .then(response => {
            commit('setChild', [
              response.data[action],
              childItemName,
            ])
            resolve()
          })
          .catch(error => {
            dispatch('openAlertBox', [
              'alertError',
              error.statusText,
            ], { root: true })
            reject(error)
          })
      })
    })

    // return new Promise((resolve, reject) => {
    //   Vue.http.get(`${path}/${id}`)
    //     .then((response) => {
    //       commit('setChild', [
    //         response.body,
    //         childItemName,
    //       ])
    //       resolve()
    //     }, (error) => {
    //       dispatch('openAlertBox', [
    //         'alertError',
    //         error.statusText,
    //       ], { root: true })
    //     })
    // })
  },
  runItemsViewRefreshing ({ commit }) {
    commit('refreshTable', true)
    setTimeout(() => {
      commit('refreshTable', false)
    }, 2000)
  },
}

export default actions
